<div class="modal-header">
    <h4 class="modal-title pull-left">{{conditionalBlockData['title']}}</h4>
</div>
<div class="modal-body">
    <form class="no-form-style" *ngIf="form" [formGroup]="form" novalidate>
        <div class="cs-d-flex flex-column">
            <div class="cs-helper-section bg-white cs-border cs-border--bottom">
                <div class="cs-help-text-color p--15">{{conditionalBlockData['description']}}</div>
            </div>
            <div class="cs-flex-1">
                <div class="cs-block-widget--form cs-d-flex flex-column">
                    <div class="cs-block-widget--form-control">
                        <label class="control-label required_field">Select a conditional field:</label>
                        <div>
                            <select class="full-width-select2 cs-select2-wfe default-input-height"
                                formControlName="col_name"
                                csSelect2
                                ($instance)="setSelect2Instance($event)"
                                [select2Config]="{}">
                                <option value="" translate>Please.Choose</option>
                                <option *ngFor="let field of fields" [value]="field.col_name">{{field.text}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer" *ngIf="form">
    <ng-container>
        <button *ngIf="showDeleteBtn" class="btn btn-danger btn-medium float-left" (click)="remove()" type="button">Delete </button>
        <button class="btn btn-link" (click)="closeModal()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="!form.valid || isFormSubmitted" (click)="save()">
            <span *ngIf="!isFormSubmitted" translate>Save</span>
            <span *ngIf="isFormSubmitted" translate>Saving</span>
        </button>
    </ng-container>
</div>
